import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export function consigneeValidator(
  maxLength: number,
  regex: RegExp,
): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const value = control.value;
    const errors: ValidationErrors = {};

    if (value?.length > maxLength) {
      errors['maxLengthExceeded'] = true;
    }

    if (value && !regex.test(value)) {
      errors['invalidCharacters'] = true;
    }

    return Object.keys(errors).length ? errors : null;
  };
}
